import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tv, Shield, TrendingUp, Target } from 'lucide-react';

const iconMap = {
  Tv: Tv,
  Shield: Shield,
  TrendingUp: TrendingUp,
  Target: Target
};

const WhyChooseUs = () => {
  const { t } = useTranslation();
  const reasons = t('whyChooseUs.reasons', { returnObjects: true });
  const icons = ['Tv', 'Shield', 'TrendingUp', 'Target'];
  
  return (
    <section className="py-24 px-6 bg-dark-bg">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-cream-gold via-cream-gold-light to-cream-gold bg-clip-text text-transparent leading-tight">
            {t('whyChooseUs.title')}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {reasons.map((item, index) => {
            const IconComponent = iconMap[icons[index]];
            return (
              <div 
                key={index}
                className="group p-10 bg-gradient-to-br from-dark-card to-burgundy-darker rounded-3xl hover:shadow-2xl hover:shadow-cream-gold/30 transition-all duration-300 hover:-translate-y-2 border-2 border-burgundy hover:border-cream-gold"
              >
                <div className="mb-6 inline-block p-4 bg-gradient-to-br from-cream-gold to-cream-gold-dark rounded-2xl group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <IconComponent className="w-8 h-8 text-burgundy-darkest" />
                </div>
                <h3 className="text-2xl font-bold text-cream-gold mb-4">
                  {item.title}
                </h3>
                <p className="text-cream-gold-light/80 leading-relaxed text-lg">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
